import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { useEffect, useState } from 'react';
import '@/App.css';
import Home from './pages/Home';
import Products from './pages/Products';
import ProductDetail from './pages/ProductDetail';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import Header from './components/Header';
import Footer from './components/Footer';
import { Toaster } from './components/ui/sonner';

function App() {
  const [cartCount, setCartCount] = useState(0);

  const updateCartCount = () => {
    const sessionId = localStorage.getItem('session_id') || generateSessionId();
    fetch(`${process.env.REACT_APP_BACKEND_URL}/api/cart/${sessionId}`)
      .then(res => res.json())
      .then(data => {
        const count = data.items?.reduce((sum, item) => sum + item.quantity, 0) || 0;
        setCartCount(count);
      })
      .catch(err => console.error('Failed to update cart count:', err));
  };

  const generateSessionId = () => {
    const id = 'session_' + Math.random().toString(36).substr(2, 9) + Date.now();
    localStorage.setItem('session_id', id);
    return id;
  };

  useEffect(() => {
    updateCartCount();
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <Header cartCount={cartCount} />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/products" element={<Products />} />
          <Route path="/products/:id" element={<ProductDetail updateCartCount={updateCartCount} />} />
          <Route path="/cart" element={<Cart updateCartCount={updateCartCount} />} />
          <Route path="/checkout" element={<Checkout updateCartCount={updateCartCount} />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
        </Routes>
        <Footer />
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;